import { render, staticRenderFns } from "./Agreement2.vue?vue&type=template&id=d569f5fe&scoped=true"
import script from "./Agreement2.vue?vue&type=script&lang=js"
export * from "./Agreement2.vue?vue&type=script&lang=js"
import style0 from "./Agreement2.vue?vue&type=style&index=0&id=d569f5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d569f5fe",
  null
  
)

export default component.exports